import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Auto_ACCGL = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);

    useImperativeHandle(ref, () => ({

        Bind(search) {
            var RequestOptions = {
                data: {
                    'Title': search,
                    'IsActive': 1,
                },
                url: General.ApiRoute() + "/Account_GeneralLedger/Search",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(result => {
                        var tmp = []
                        console.dir(result.data)
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                value: result.data[i].id +"|" +
                                    result.data[i].label,
                                label: result.data[i].label,

                            })
                        }
                        setList(tmp)
                    })
                    .catch((error) => {
                        console.dir(error)
                    })
            )

        },
        focus() {
            const inputElement = document.querySelector('.FocusACCGLAuto input');
            if (inputElement) {
                inputElement.focus();
            }
        }
    }),
        [props.value])

    return (
        <rsuite.AutoComplete
            data={List.map((product) => ({
                label: `${product.label}`,
                value: `${product.value}`,
            }))}
            value={props.value}
            label={props.label}
            onChange={(event) => props.onChange(event)}
            onSelect={(event) => props.onSelect(event)}
            // onKeyUp={(event) => props.onKeyUp(event)}

            className='FocusACCGLAuto'
        />)
});

export default Auto_ACCGL;